import { EventType } from './../interfaces/event-type';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

import { NetworkService, } from './network.service';
import { switchMap } from 'rxjs/operators';
import { Storage } from '@ionic/storage';
import { CompanyService } from './company.service';

@Injectable({
  providedIn: 'root'
})
export class EventTypeService {
  constructor(
    private http: HttpClient,
    private network: NetworkService,
    private storage: Storage,
    private companyService: CompanyService
  ) { }





  getEventTypesOfCompany(companyId: string): Observable<EventType[]> {
    return this.http.get<EventType[]>(
      `${environment.url}/bucket/${environment.buckets.eventType}/data/?relation=true&filter={"company._id":"${companyId}"}`
    );
  }

  getService(id: string): Observable<EventType> {
    return this.http.get<EventType>(
      `${environment.url}/bucket/${environment.buckets.eventType}/data/${id}`
    );
  }

  insert(service: EventType, companyId: string) {
    // service.valid_from = this.convertToServerTime(service.valid_from);
    // service.valid_to = this.convertToServerTime(service.valid_to);

    // service.company = companyId;

    let savedService: EventType;
    return this.http
      .post<EventType>(`${environment.url}/bucket/${environment.buckets.eventType}/data`, service)
      .pipe(
        switchMap(s => {
          savedService = s;
          return this.companyService.getCompanyById(companyId);
        }),
        switchMap(company => {
          company.services.push(savedService._id);

          console.log("UPDATE COMPANY")
          return this.companyService.updateCompany(company);
        }),
        switchMap(() => {
          return of(savedService);
        })
      );
  }

  delete(id: string) {
    return this.http.delete(`${environment.url}/bucket/${environment.buckets.eventType}/data/${id}`);
  }

  update(service: EventType) {
    // service.valid_from = this.convertToServerTime(service.valid_from);
    // service.valid_to = this.convertToServerTime(service.valid_to);

    return this.http.put<EventType>(
      `${environment.url}/bucket/${environment.buckets.eventType}/data/${service._id}`,
      service
    );
  }

}
